import React, { useState, useEffect } from 'react';
import { Collapse } from 'react-bootstrap';
import { useSelector, useDispatch } from "react-redux";
import { Link, useHistory } from 'react-router-dom';
import '../../../../styles/smart_wizard_all.css';
import { currencyConvertor, getApplicationFlow, getAttributeToVerify, isEclipseOpsTruck, setControlNumber, showAlert } from '../../../../Utils/Utility';
import BilledHeader from './BilledHeader';
import { upperFirst } from 'lodash';
import { injectIntl } from 'react-intl';
import { verifyPhoneNumber } from "@mobile-dev/platform/common/redux/actions/AmplifyUserAction"
import { clearError, clearSubmitVerifyPhone } from '@mobile-dev/platform/common/redux/actions/CommonAction';
import { AppConstatnt } from '../../../../Utils/AppConstant';
import { getFormattedDate } from '../../../Common/DateUtils';
import { toast } from 'react-toastify';

function BillingDetails({ intl, ...props }) {

    const [phoneVerified, setphoneVerified] = useState(null)
    const [emailverified, setemailverified] = useState(null)
    const [mobileNumber, setmobileNumber] = useState(null)
    const history = useHistory()
    const billedData = useSelector(state => state.billed.billedPo);
    const verifyPhoneData = useSelector(state => state.amplifyUser.verifyPhoneData)
    const error = useSelector(state => state.amplifyUser.error)
    const { formatMessage } = intl;
    const id = props.match.params.id;
    const load = billedData.loads.find(load => load.load_id === id);
    const dispatch = useDispatch()
    let totalfeeamount = 0;
    load.fees && load?.fees.map((fee) => {

        totalfeeamount = totalfeeamount + fee.fee_amount
    });
    let unload_bill_amount = currencyConvertor(load.unloading_bill_amount);
    let total_bill_amount = currencyConvertor(load.total_bill_amount);
    let total_paid = currencyConvertor(load.total_paid);
    const loadId = load.load_id;
    const user = useSelector(state => state.amplifyUser.user)
    let controlNumber = null;

    useEffect(() => {
        showAlert(toast.TYPE.WARNING, formatMessage({ id: "app.PAYMENT_DUE_DISCLAIMER" }));
    }, [])

    useEffect(() => {
        if (user) {
            setphoneVerified(user.attributes?.phone_number_verified)
            setmobileNumber(user.attributes?.phone_number)
            setemailverified(user.attributes['custom:emailVerify'])
        }
    }, [user])

    useEffect(() => {
        if (verifyPhoneData && verifyPhoneData === "SUCCESS") {
            dispatch(clearSubmitVerifyPhone())
            history.push({
                pathname: `/Otp`,
                state: {
                    mobileNumber: mobileNumber,
                    unload_bill_amount: unload_bill_amount,
                    loadId: loadId,
                    id: id
                } // your data array of objects
            })
        }
    }, [verifyPhoneData])

    if (load) {
        controlNumber = load.load_control_num;
        setControlNumber(controlNumber);
    }
    const [showText, setShowText] = useState(false);

    const handleCollapse = () => {
        setShowText(!showText);
    }

    const validateAndNavigate = (id) => {
        // if (isEclipseOpsTruck(load)) {
            history.push({
                pathname: `/selectpayment/${id}`,
                state: { amount: load.total_bill_amount, selection: "Full Payment", remainingAmount: 0, totalremainingAmount: 0, total_bill_amount: load.total_bill_amount, tin: load.tax_id } // your data array of objects
            });
        // } else {
        //     history.push({
        //         pathname: `/selectpayment/${id}`,
        //         state: { amount, selection, remainingAmount, totalremainingAmount, total_bill_amount, tin } // your data array of objects
        //     });
        //     return null;
        //     history.push({
        //         pathname: `/paymentdetails/${id}`,
        //         state: { unload_bill_amount, loadId } // your data array of objects
        //     })
        // }
    }

    const onPay = (id) => {
        if (getApplicationFlow() === AppConstatnt.flow.DRIVER && phoneVerified) {
            validateAndNavigate(id)
        } else if (getApplicationFlow() !== AppConstatnt.flow.DRIVER && emailverified === "true") {
            validateAndNavigate(id)
        }
        else {
            dispatch(verifyPhoneNumber(getAttributeToVerify()))
        }
    }


    return (
        <div className="content-page">
            <div className="content">
                <div className="contest_input_block">
                    <div className="contest_preview">
                        <BilledHeader path='/' />
                        <div className="container_block" style={{ padding: '40px' }}>
                            <div id="smartwizard" className="sw sw-theme-dots sw-justified">

                                <div id="step-1" className="tab-pane custom-scrollBar" role="tabpanel" aria-labelledby="step-1">
                                    <section>
                                        <div className="row">
                                            {/* <div className="col-sm-4 col-xxl-4"> */}
                                                {/* <section>
                                                    <div className="row">
                                                        <div className="form-group col-sm-12  tbl">
                                                            <table>
                                                                <tbody> */}

                                                                    {/* {
                                                                        !isEclipseOpsTruck(load) &&
                                                                        < tbody >
                                                                            <tr>
                                                                                <td colspan="3"><h4 className="mb-2 p-0 txtwhite">{formatMessage({ id: "app.payment_due_details" })}</h4></td>
                                                                            </tr>
                                                                            < tr >
                                                                                <td className="col-9 p-0 text-danger"><b>{formatMessage({ id: "app.total_charges" })}</b></td>
                                                                                <td className="text-danger"><b>${total_bill_amount}</b></td>
                                                                            </tr>
                                                                        </tbody>
                                                                    } */}

                                                                    {/* {total_paid > 0 && !isEclipseOpsTruck(load) &&
                                                                        <tr>
                                                                            <td className="col-9 p-0 text-danger"><b>{formatMessage({ id: "app.total_charges_paid" })}</b></td>
                                                                            <td className="text-danger"><b>${total_paid}</b></td>
                                                                        </tr>
                                                                    } */}
                                                                    {/* {
                                                                        !isEclipseOpsTruck(load) &&
                                                                        <tbody>
                                                                            <tr>
                                                                                <td colSpan='3'><h4 className="mb-2 mt-2 txtwhite">{formatMessage({ id: "app.itemized_charges" })}</h4>

                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td className="col-9 p-0">{formatMessage({ id: "app.unloading" })}</td>
                                                                                <td>${unload_bill_amount}</td>
                                                                            </tr>
                                                                        </tbody>

                                                                    } */}
                                                                    {/* {load.fees && load?.fees.map((fee, index) => {

                                                                        return (
                                                                            <>
                                                                                {fee.fee_amount &&
                                                                                    <tr key={index}>

                                                                                        <td className="col-9 p-0">{fee.fee_type}</td>
                                                                                        <td>${currencyConvertor(fee.fee_amount)}</td>

                                                                                    </tr>
                                                                                }
                                                                            </>
                                                                        )

                                                                    })} */}
                                                                {/* </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </section> */}

                                            {/* </div> */}

                                            <div className="col-sm-5 col-xxl-4">
                                                <section>
                                                    <div className="row">
                                                        <div className="form-group col-sm-12 tbl">
                                                            <table>
                                                                <tbody>
                                                                    {
                                                                        !isEclipseOpsTruck(load) &&
                                                                        <tbody>
                                                                            <tr>
                                                                                <td colspan="2"><h4 className="mb-2 txtwhite">{formatMessage({ id: "app.labor_details" })} </h4></td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td className="col-7 p-0">{formatMessage({ id: "app.unloading_started" })} :</td>
                                                                                <td>{getFormattedDate(load.unload_start_time)}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td className="col-7 p-0">{formatMessage({ id: "app.unloading_ended" })} :</td>
                                                                                <td>{getFormattedDate(load.unload_end_time)}</td>
                                                                            </tr>
                                                                        </tbody>
                                                                    }
                                                                    <tr>
                                                                        <td colspan="2"><h4 className="mt-2 mb-2 txtwhite">{formatMessage({ id: "app.load_labor_type" })} </h4></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="col-7 p-0"> {upperFirst(load.load_type.toLowerCase())}/{upperFirst(load.labor_type.toLowerCase())}</td>
                                                                        <td></td>
                                                                    </tr>
                                                                    {load?.start_pallets && load?.end_pallets &&
                                                                        <tr>
                                                                            <td className="col-7 p-0">{formatMessage({ id: "app.start_end_pallets" })}</td>
                                                                            <td>{load?.start_pallets}/{load?.end_pallets}</td>
                                                                        </tr>
                                                                    }

                                                                    {load?.special_circumstances && load.special_circumstances[0].name &&
                                                                        <>
                                                                            <tr>
                                                                                <td colspan="2"><h4 className="mt-2 mb-2 txtwhite">{formatMessage({ id: "app.special_circumstances" })} </h4></td>
                                                                            </tr>

                                                                            {load.special_circumstances.map((spc, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <td key={index}>{upperFirst(spc.name.toLowerCase())}</td>
                                                                                        <td>{spc.units && `${spc.units} ${upperFirst(spc.unit_type.toLowerCase())}`}</td>
                                                                                    </tr>
                                                                                )
                                                                            })}

                                                                        </>
                                                                    }

                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </section>
                                            </div>
                                            <div className="col-sm-3 col-xxl-4">
                                                <div className="row">
                                                    <div className="form-group col-sm-6">

                                                        <h4 className="mb-2 txtwhite">{formatMessage({ id: "app.po" })}</h4>

                                                        {!showText ?
                                                            <>
                                                                {load.pos.slice(0, 4).map((po, index) => {
                                                                    return (
                                                                        <p key={index}>{po.po_number}</p>
                                                                    )
                                                                })}
                                                                {load.pos.length > 4 &&
                                                                    < a href="javascript:void(0);" onClick={handleCollapse} >{formatMessage({ id: "app.see_more" })}</a>
                                                                }
                                                            </>
                                                            :
                                                            <>

                                                                <Collapse in={showText}>
                                                                    <div>
                                                                        {load.pos.map((po, index) => {
                                                                            return (
                                                                                <p key={index}>{po.po_number}</p>
                                                                            )
                                                                        })}
                                                                    </div>
                                                                </Collapse>
                                                                {load.pos.length > 4 &&
                                                                    < a href="javascript:void(0);" onClick={handleCollapse} >{formatMessage({ id: "app.see_less" })}</a>
                                                                }
                                                            </>
                                                        }
                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                    </section>
                                </div>
                                <div className="toolbar toolbar-bottom" role="toolbar" style={{ textAlign: "right" }}>
                                    <button
                                        onClick={() => onPay(id)}
                                        className="btn sw-btn-next btn-chartreuse float-right " type="button">{formatMessage({ id: "app.pay" })}</button>
                                </div>
                            </div>


                        </div>

                    </div>
                </div >
            </div >
        </div >

    )

}


export default injectIntl(BillingDetails);
